Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "noeventslink166315476",
  {"root":"noeventslink166315476--root","mobile":"noeventslink166315476--mobile"},
  "",
  8,
  "noeventslink166315476"
);

